import ApiClient from '@/api/ApiClient';
import CourseModuleVideoResourse from '@/api/models/CourseModuleVideoResourse';
import utils from '@/composables/utils';
import store from '@/store';

class CourseVideoResourseService {
    #prefixUrl = 'api/resourse/';

    constructor() {
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Gets this video resourses
     * @param {integer} videoId
     * @return {Array}
     */
    async getVideoResourse(videoId = null) {
        const response = await this.api.executeRequest(`/video/${videoId}`, {}, this.api.methods.GET);
        if (!response.success())
            return [];

        let videoResourses = [];
        for(let res of response.getContent()){
            videoResourses.push(new CourseModuleVideoResourse(res));
        }

        return videoResourses;
    }

    /**
     * Tries to get cached video resourse
     * @param {integer} videoId 
     * @return {any|null}
     */
    getCachedVideoResourse(videoId = null) {
        const cachedData = store.getters.getOnDataChest(`course_module_video_resourses_${videoId}`);
        return !utils.isEmpty(cachedData) ? cachedData : null;
    }

    /**
     * Tries to get cached video lesson
     * @param {integer} videoId 
     * @return {any|null}
     */
    extractLessonFromVideo(videoObj = null) {
        if(!videoObj)
            return null;
        return videoObj.lesson;
    }

    /**
     * Tries to get resourse blob data
     * @param {integer} resourseId 
     * @returns {blob|null}
     */
    async fetchDonwloadData(resourseId = null) {
        return await this.api.executeRequest(`download/${resourseId}`, {}, this.api.methods.GET, {responseType: 'blob'});
    }

    /**
     * Saves video resource
     * @param {object} resourseData
     * @returns {api/models/Response}
     */
    async saveVideoResourse(resourseData = {}, id = null) {
        const response = await this.api.executeRequest(
            `/${id}`, 
            resourseData, 
            this.api.methods.POST,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }
        );

        return response;
    }

    /**
     * Removes video resourse
     * @param {integer} videoResourseId
     */
    async removeResourse(videoResourseId = null) {
        return await this.api.executeRequest(`/${videoResourseId}`, {}, this.api.methods.DELETE);
    }
}

export default new CourseVideoResourseService();
